import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { ButtonProps } from '@material-ui/core/Button/Button';
import GetAppIcon from '@material-ui/icons/GetAppOutlined';
import { DIALOGS } from 'src/models/DialogModel';
import { openDialog } from 'src/redux/actions/dialogActions';
import { useAppDispatch, Store } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { t } from 'src/lib/language';

const ExportPaymentButton = (props: ButtonProps) => {
  const { disabled } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);

  const handleOpen = () => {
    dispatch(openDialog({ dialog: DIALOGS.paymentExport }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.export_payment')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.download}
            onClick={handleOpen}
            disabled={disabled}>
            <GetAppIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default ExportPaymentButton;
